<template>
  <div>
    <div class="action report-an-issue" @click="handleClick">Report an Issue</div>
    <report-review-issue-modal v-if="showModal" :assignment="assignment" :reportReasons="reportReasons" @close="showModal=false"></report-review-issue-modal>
  </div>
</template>
<script>

import { mapState } from "vuex";
import ReportReviewIssueModal from '@/components/Page/ReportReviewIssue';

export default {
  name: "ReportAnIssue",
  props: ["assignment","reportReasons"],
  components: {
    "report-review-issue-modal": ReportReviewIssueModal
  },
  computed: {},
  data: function() {
    return {
      showModal: false
    }
  },
  methods: {
    handleClick() {
      this.showModal = !this.showModal
    }
  }
};

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

</script>

<style lang="scss" scoped>
.action {
  display: inline-block;
}
.report-an-issue {
  margin: 0;
  margin-top: -6px;
  font-size: 10.5pt !important;
  color: #999;
  background: #f2f2f2;
  // color: $color-red;
  // background-color: lighten($color-red, 30%);
}
</style>



